module.exports = __webpack_public_path__ + "img/工具箱背景.e3d8b111.png";